import { trendingSwiper, heroSwiper, carouselModuleSwiper } from './_swiper';

window.addEventListener('DOMContentLoaded', () => {
  heroSwiper();
  trendingSwiper();
  carouselModuleSwiper();
});
